import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../Layout/Layout';
// import DataTable from 'react-data-table-component';
import DataTable from "react-data-table-component";
import { Link, useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { FaEye } from "react-icons/fa";
import { getreportlist } from '../../actions/users';
import moment from 'moment';

const ReportList = () => {


    const navigate = useNavigate()


    const [reportList, setReportList] = useState([]);
    const [searchText, setSearchText] = useState("");

    const getReportList = async () => {
      var test = await getreportlist({searchText});

      setReportList(test?.data);
  }
  
  useEffect(() => {
  //logout(history)
  getReportList();
  }, [searchText]);

    const columns = [
        {
          key: "ind",
          name: "S.No",
          className: "name",
          align: "left",
          sortable: false,
          cell:(row, index, column, id)=>
          <p>{index+1}</p>
      
        },
        {
      
          key: "Report",
          name: "Report",
          // className: "tokenId",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.report}</p>
          ),
      
        },
        {
          key: "Item Name",
          name: "NFT Name",
          // className: "Name",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.imageName}</p>
          ),
      
        },
        {
      
          key: "Image Hash Value",
          name: "NFT Hash Value",
          // className: "tokenCreator",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.imagehash}</p>
          ),
         
      
        },{
      
          key: "Image Owner",
          name: "NFT Owner",
          // className: "tokenOwner",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.imageOwner}</p>
          ),
      
      
        },
        {
      
          key: "Image Count No",
          name: "NFT ID",
          // className: "tokenCategory",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.imageId}</p>
          ),
      
        },
        {
      
          key: "Image Contract Address",
          name: "NFT Contract Address",
          // className: "tokenRoyality",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.imageContractAddress}</p>
          ),
      
        },
        {
      
          key: "Image Type",
          name: "NFT Type",
          // className: "tokenBid",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.imageType}</p>
          ),
      
        },
        {
      
          key: "No Of Items",
          name: "No Of NFT",
          // className: "tokenBid",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.noofitems}</p>
          ),
      
        },
        {
      
          key: "Report By",
          name: "Report By",
          // className: "tokenQuantity",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.currAddr}</p>
          ),
      
        },
        
        {
      
          key: "No of Burned items",
          name: "No Of Burned Items",
          // className: "balance",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{row?.burnToken}</p>
          ),
      
      
        },
        
        {
      
          key: "Created At",
          name: "Created At",
          // className: "tokenPrice",
          align: "left",
          sortable: false,
          cell: (row, index, column, id) =>(
            <p>{moment(row?.date).format('MMMM,Do YYYY, hh:mm A')}</p>
          ),
      
      
        },
        // {
      
        //   key: "View Token",
        //   name: "View Token",
        //   // className: "tokenPrice",
        //   align: "left",
        //   sortable: false,
        //   cell: record =>
        //   // <div>{record.clocktime}</div>
        //   <div><p>{}</p></div>
      
      
        // },
        
        {
          key: "View Token",
          name: "View Token",
          // className: "action",
          width: 200,
          align: "left",
          sortable: false,
          cell: (row, index, column, id) => {
              return (
              <Fragment>
                <button
                  data-toggle="modal"
                  data-target="#update-template-modal"
                  className="btn btn-primary btn-sm"
                  onClick={() => navigate(`/ViewReport/${row._id}`)}
      
                  style={{ marginRight: '5px' }}
                  >
                  <FaEye />
                </button>
               </Fragment>
            );
          }
        },
        // {
        //   key: "Hide/show",
        //   text: "Actions",
        //   className: "action",
        //   width: 200,
        //   align: "left",
        //   sortable: false,
        //   cell: record => {
        //       return (
        //       <Fragment>
        //          <input type="checkbox"
                
        //           // checked={isItemSelected(record.tokenOwnerDb._id)}
        //           // onChange={(e)=>{hideshow(e,record)}}
        //           />
        //        </Fragment>
        //     );
        //   }
        // },
      ];

    return (
        <Layout>
            <div className="reportlist">
                <h1 className="pagehead">Report List</h1>
                <div className="cardbox">
                    <div className="tablebox">
                        <Form.Control type="text" onChange={(e)=>setSearchText(e?.target?.value)} value={searchText} placeholder="Filter in records" />
                        <DataTable
                            className='react-datatables'
                            columns={columns}
                            data={reportList}
                            pagination // Enable pagination
                            // paginationPerPage={2} // Rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ReportList;